var styles = {"icons":"styles_icons__-G-gJ","children":"styles_children__NtWZI","noSpacing":"styles_no-spacing__chcqz","compactSpacing":"styles_compact-spacing__Dwr7v","comfortableSpacing":"styles_comfortable-spacing__Oz54y","looseSpacing":"styles_loose-spacing__hcqgt","actions":"styles_actions__h-SEo"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
